import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteMySavedPasswordsAndCredentialsParams {
}

export interface IDeleteMySavedPasswordsAndCredentialsResult extends IResult {
}

export class DeleteMySavedPasswordsAndCredentialsRequest
  extends Request<IDeleteMySavedPasswordsAndCredentialsParams, IDeleteMySavedPasswordsAndCredentialsResult> {

  constructor(params: IDeleteMySavedPasswordsAndCredentialsParams = {}) {
    super('deleteMySavedPasswordsAndCredentials', params);
  }
}
